module.exports = __webpack_public_path__ + "img/ExcelLife.e79fad29.png";